var default_styles_default = {
  "button_container": "GK-Xo",
  "button_margin": "_9I-I2",
  "button_text": "QFer6",
  "button_size_content": "nmS3k"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
